export const SESSION_STORAGE_KEY = 'oxford-favourite-vehicle'

export const handlePostAuthFavourite = (
  addFavourite: (vehicleId: string) => Promise<void>,
  isLoggedIn: boolean,
) => {
  const oxfordFavouriteVehicle = sessionStorage.getItem(SESSION_STORAGE_KEY)

  if (isLoggedIn && oxfordFavouriteVehicle) {
    const preAuthFavouriteVehicle = JSON.parse(oxfordFavouriteVehicle)

    addFavourite(preAuthFavouriteVehicle.id)
    sessionStorage.removeItem(SESSION_STORAGE_KEY)
  }
}
